import inventoryUpdateQuickview from './inventoryUpdate-quickview.html'

const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler        = require('../../../../../components/dt/dt-handler')

/****************ELEMENTS*****************/
var htmlQf          = {}
var HTMLwasSelected = false

function HTMLselect(detail){

      quickviewHandler.HTMLselect(
            'inventoryUpdate',
            'inventoryUpdate-quickview',
            detail.ev?.target,
            inventoryUpdateQuickview,
            htmlQf)

      HTMLwasSelected = true
}
/**/

export function start(detail){

      if(!HTMLwasSelected){ HTMLselect(detail) }

      obj[detail.act].start(detail)
}
/**/

const obj = {

      show: { start: (detail)=>{ show(detail)                           }},
      hide: { start: (detail)=>{ quickviewHandler.hide(detail, htmlQf) }},
}
/**/

function show(detail){

      fillTable(detail.lines)
      quickviewHandler.show(detail, htmlQf)
}

function fillTable(lines){

      const data = lines.map((line)=>{
            return {
                  purchase_code: escapeHTML(line.purchase_code),
                  item:          escapeHTML(line.item),
                  unit:          escapeHTML(line.unit),
                  available_qty: line.available_qty,
                  entered_qty:   line.entered_qty,
            }
      })

      const columns = [
            {key: 'purchase_code', label: 'PO'},
            {key: 'item', label: 'Item'},
            {key: 'unit', label: 'Unit'},
            {key: 'available_qty', label: 'Available Qty', format: 'int'},
            {key: 'entered_qty', label: 'Entered Qty', format: 'int'},
      ]

      const container = document.createElement('div')
      container.innerHTML = dtHandler.dtSimpleFc(data, columns)

      container.querySelectorAll('tbody tr').forEach((row)=>{
            const enteredQty = row.querySelectorAll('.value-text')[4]

            enteredQty.classList.add('font-red')
            enteredQty.style.fontWeight = '700'
      })

      const table = htmlQf.quickviewHTML.querySelector('#inventoryUpdate-quickview-table')
      table.innerHTML = container.innerHTML
}

function escapeHTML(value){

      return `${value ?? ''}`
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;')
}
